import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPicartoDotTvComponent } from './simple-icons-picarto-dot-tv.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPicartoDotTvComponent ],
    exports:      [ SimpleIconsPicartoDotTvComponent ],
    bootstrap:    []
})
export class SimpleIconsPicartoDotTvModule {}
